import styled from "styled-components";
import { isSameMonth } from "date-fns";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2px;
  text-align: center;
`;

const Month = styled.button<{
  disabled: boolean;
  isCurrent: boolean;
}>`
  padding: 10px 8px;
  border: none;
  border-radius: 4px;
  color: ${({ disabled, isCurrent }) => {
    if (disabled) return "#c0c0c0";
    return isCurrent ? "#ffffff" : "#202227";
  }};
  background-color: ${({ isCurrent }) =>
    isCurrent ? "#337ab7" : "transparent"};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  &:hover {
    ${({ disabled, isCurrent }) => {
      if (!disabled && !isCurrent) return "background:#f0f0f0";
    }};
  }
`;

export type MonthViewProps = {
  setCurrentlyShownMonth: React.Dispatch<React.SetStateAction<Date>>;
  currentlyShownYear: Date;
  /**
   * Overrides the actual current month for testing purposes only.
   */
  currentMonth?: Date;
};

export const MonthView: React.FC<MonthViewProps> = ({
  setCurrentlyShownMonth,
  currentlyShownYear,
  currentMonth,
}) => {
  const currentMonthDate = currentMonth || new Date();

  const monthDates = [];
  for (let i = 0; i < 12; i++) {
    monthDates.push(new Date(currentlyShownYear.getFullYear(), i, 1));
  }

  const isMonthPast = (date: Date) => {
    return (
      new Date(date.getFullYear(), date.getMonth(), 1) <
      new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth(), 1)
    );
  };

  return (
    <Container data-id="month-view-container">
      {monthDates.map((date) => (
        <Month
          type="button"
          disabled={isMonthPast(date)}
          isCurrent={isSameMonth(date, currentMonthDate)}
          onClick={() => setCurrentlyShownMonth(date)}
          data-id={`month-${date.getMonth() + 1}`}
        >
          {date.toLocaleString("default", { month: "short" })}
        </Month>
      ))}
    </Container>
  );
};

export default MonthView;
